<template>
   <el-table
        :cell-style="{padding: '4px 0'}"
        :data="standardCode"
        :show-header="false"
        :max-height="280"
        style="width: 100%;">
        <el-table-column
            max-width="200"
            prop="name"
            label="姓名">
            <template slot-scope="row">
                <span v-if="row.row.value">{{row.row.name}}</span>
            </template>
        </el-table-column>
        <el-table-column
            prop="value"
            label="地址">
            <template slot-scope="row" >
                <span v-if="row.row.value">{{row.row.value}}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        props: ['standardCode'],
    };
</script>

<style>
</style>
